export default __webpack_public_path__ + "static/media/Robe of Fiendish Invocation.7b273954.jpg";